import { render } from "./historialPagosOk.vue?vue&type=template&id=1b93412c"
import script from "./historialPagosOk.vue?vue&type=script&lang=js"
export * from "./historialPagosOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__